import duiCapitalize from './dui-capitalize/dui-capitalize';
import duiPlainText from './dui-plain-text/dui-plain-text';
import duiPluralize from './dui-pluralize/dui-pluralize';
import duiThousands from './dui-thousands/dui-thousands';
import duiTruncate from './dui-truncate/dui-truncate';

export default {
  'duiCapitalize': duiCapitalize,
  'duiPlainText': duiPlainText,
  'duiPluralize': duiPluralize,
  'duiThousands': duiThousands,
  'duiTruncate': duiTruncate,
};
